import React from 'react';

const ArrowPrev = ({...props}) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="11" height="17" viewBox="0 0 11 17" fill="none">
            <path d="M8.95703 15.0332L2.26858 8.41309L8.95703 1.79297" stroke="#6E7074" strokeWidth="2" strokeLinecap="square" />
        </svg>
    )
}

export default ArrowPrev;